export default "__VITE_ASSET__ht4YMLU3__"